
export const ACT_ON_BEHALF_KEY = 'impersonate';
export const ACT_ON_BEHALF_HEADER = 'CustomerNumber';
export const ACT_ON_BEHALF_MARKET_KEY = 'customerMarket';
export const ACT_ON_BEHALF_MARKET_HEADER = 'CustomerMarket';